/* Variant updates use v10's server-rendered section event, scoped to this product. */
class EgdProductRules extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController()
    document.addEventListener(`variant:change:${this.dataset.sectionId}:${this.dataset.productId}`, (event) => {
      const { html, variant, loading } = event.detail
      this.toggleAttribute('aria-busy', Boolean(loading))
      if (loading) {
        this.querySelectorAll('input, button').forEach((control) => { control.disabled = true })
        return
      }
      const next = html?.getElementById(this.id)
      if (variant && next) {
        this.innerHTML = next.innerHTML
        this.hidden = false
      } else {
        // Do not leave another variant's availability promise or quantity active.
        this.hidden = true
        this.querySelectorAll('input, button').forEach((control) => { control.disabled = true })
      }
    }, { signal: this.controller.signal })
  }
  disconnectedCallback() { this.controller?.abort() }
}
if (!customElements.get('egd-product-rules')) customElements.define('egd-product-rules', EgdProductRules)
